export default "__VITE_ASSET__masDcyZ1__"